<template>
  <div class="warp-draggable-item" :class="{'warp-draggable-item-disabled': itemData.disabled}">
    <div class="tx-hide" style="flex:1">{{itemData.label}}</div>
    <div class="warp-button-box">
      <span class="guding1" v-if="itemData.fixed === 0 && itemData.disabled !== 1 && fixedNum < 6" @click.stop.prevent="fixed" />
      <span class="guding2" v-if="itemData.fixed === 1 && itemData.disabled !== 1" @click.stop.prevent="fixed" />
    </div>
    <div class="warp-button-box">
      <span class="close" v-if="itemData.disabled === 0" @click.stop.prevent="remove" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'draggableItem',
  props: {
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    fixedNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    fixed() {
      this.itemData.fixed = this.itemData.fixed ? 0 : 1
      this.$emit('update')
    },
    remove() {
      this.itemData.enable = 0
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
.warp-draggable-item{
  height: 28px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: $main-color;
  background-color: #F7FAFE;
  border-radius: 2px;
  margin-top: 8px;
  border: 1px solid $B2;
  .warp-button-box{
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 16px;
      height: 16px;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .guding1{
      background-image: url('../../../assets/images/Table/guding1.png');
      display: none;
    }
    .guding2{
      background-image: url('../../../assets/images/Table/guding2.png');
    }
    .close{
      background-image: url('../../../assets/images/Table/cha.png');
      display: none;
    }
  }
  &:hover{
    background-color: $main-color;
    color: #ffffff;
    .guding1, .close{
      display: block;
    }
    .guding2{
      background-image: url('../../../assets/images/Table/guding1.png');
    }
  }
  &.sortable-chosen {
    color: #ffffff;
    background: $main-color;
    cursor: pointer;
  }
}
.warp-draggable-item-disabled{
  color: $G7;
  background-color: $G2;
  border: 1px solid $G4;
  &:hover{
    background-color: $G2;
    color: $G7;
  }
}
.mr10{
  margin-right: 10px;
}
</style>
